








































































































































































































import { Component, Watch } from 'vue-property-decorator';
import '@/assets/scss/pages/app-todo.scss';
import {
  CheckIcon,
  CheckSquareIcon,
  ClockIcon,
  FileTextIcon,
  HomeIcon,
  ListIcon,
  MailIcon,
  MoreVerticalIcon,
  PlusIcon,
  SquareIcon,
  StarIcon,
  Trash2Icon,
  TrashIcon,
} from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import {
  ITag,
  ITask,
  ITaskCountsResult,
  TagCategory,
  TaskFilterDto,
  TaskStatus,
} from 'admiral-core';
import { TaskApi } from '@/services/TaskApi';
import { FormatMixin } from '@/mixins/FormatMixin';
import { TagApi } from '@/services/TagApi';
import ContextMenu from '@/components/common/ContextMenu.vue';
import Multiselect from 'vue-multiselect';
import CreatePolicyModal from '@/views/pages/policies/CreatePolicyModal.vue';
import { BModal } from 'bootstrap-vue';
import CreateTaskModal from '@/views/pages/tasks/CreateTaskModal.vue';
import TaskOverview from './TaskOverview.vue';

/** v1 Tasks page combined filter (navigation “Alle”). */
const TASKS_V1_ALL_STATUSES: TaskStatus[] = [
  TaskStatus.TODO,
  TaskStatus.COMPLETED,
  TaskStatus.ARCHIVED,
];

export type ListType = 'ALL' | 'TODO' | 'COMPLETED' | 'SNOOZED' | 'IMPORTANT' | 'BACKOFFICE';

@Component({
  name: 'empty',
  components: {
    CreateTaskModal,
    CreatePolicyModal,
    ContextMenu,
    Avatar,
    MailIcon,
    CheckIcon,
    ClockIcon,
    SquareIcon,
    CheckSquareIcon,
    HomeIcon,
    StarIcon,
    PlusIcon,
    ListIcon,
    FileTextIcon,
    TrashIcon,
    Trash2Icon,
    MoreVerticalIcon,
    Multiselect,
  },
})
class Tasks extends mixins(BaseMixin, FormatMixin) {
  filter: TaskFilterDto = {
    status: [TaskStatus.TODO],
  };

  list: ListType = 'TODO';

  tasks: ITask[] = [];
  tags: ITag[] = [];

  showMenu = false;
  searchQuery = '';

  taskCounts: ITaskCountsResult = {
    ALL: 0,
    COMPLETED: 0,
    ARCHIVED: 0,
    IMPORTANT: 0,
    TODO: 0,
    BACKOFFICE: 0,
  };

  get taskFilter(): TaskFilterDto {
    return this.$store.getters['PreferencesModule/getTaskFilter'];
  }

  get showDemo(): boolean {
    return this.$store.getters['PreferencesModule/getShowDemo'];
  }

  @Watch('showDemo')
  onShowDemoChange() {
    this.loadTasks();
  }

  @Watch('taskFilter')
  async watchTaskFilter() {
    await this.loadTags();
    await this.loadTasks();
  }

  async mounted() {
    this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    await this.loadTags();
    await this.loadTasks();
  }

  isList(listType: ListType): boolean {
    if (listType === 'ALL') {
      return (
        this.filter.status.includes(TaskStatus.TODO) &&
        this.filter.status.includes(TaskStatus.COMPLETED) &&
        this.filter.status.includes(TaskStatus.ARCHIVED) &&
        this.filter.status.length === TASKS_V1_ALL_STATUSES.length &&
        !this.filter.important
      );
    } else if (listType === 'COMPLETED') {
      return this.filter.status.length === 1 && this.filter.status.includes(TaskStatus.COMPLETED);
    } else if (listType === 'TODO') {
      return this.filter.status.length === 1 && this.filter.status.includes(TaskStatus.TODO);
    } else if (listType === 'IMPORTANT') {
      return !!this.filter.important;
    }
    return false;
  }

  async showAll() {
    this.list = 'ALL';
    this.filter.status = [...TASKS_V1_ALL_STATUSES];
    delete this.filter.important;
    await this.loadTasks();
  }

  async showBackoffice() {
    this.list = this.list === 'BACKOFFICE' ? 'ALL' : 'BACKOFFICE';

    this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    this.filter.status = [...TASKS_V1_ALL_STATUSES];
    this.filter.backoffice = !this.filter.backoffice;

    await this.$store.dispatch('PreferencesModule/setTaskFilter', this.filter);

    await this.loadTasks();
  }

  async showCompleted() {
    this.list = 'COMPLETED';

    this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    this.filter.status = [TaskStatus.COMPLETED];
    delete this.filter.important;

    await this.$store.dispatch('PreferencesModule/setTaskFilter', this.filter);
    await this.loadTasks();
  }

  async showOpen() {
    this.list = 'TODO';

    this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    this.filter.status = [TaskStatus.TODO];
    delete this.filter.important;

    await this.$store.dispatch('PreferencesModule/setTaskFilter', this.filter);

    await this.loadTasks();
  }

  async showImportant() {
    this.list = 'IMPORTANT';

    this.filter = await this.$store.getters['PreferencesModule/getTaskFilter'];
    this.filter.status = [...TASKS_V1_ALL_STATUSES];
    this.filter.important = true;

    await this.$store.dispatch('PreferencesModule/setTaskFilter', this.filter);

    await this.loadTasks();
  }

  // async showSnoozed() {
  //   this.list = 'SNOOZED';

  //   const filter: TaskFilterDto = await this.$store.getters['PreferencesModule/getTaskFilter'];

  //   this.filter = filter;

  //   this.filter.status = [TaskStatus.SNOOZED];
  //   delete this.filter.important;
  //   await this.$store.dispatch('PreferencesModule/setTaskFilter', this.filter);

  //   await this.loadTasks();
  // }
  async showMyTasks() {
    if (this.filter.users && this.filter.users?.length > 0) {
      this.filter.users = [];
    } else {
      this.filter.users = [this.user];
    }
    await this.loadTasks();
  }

  myTasksSelected() {
    return this.filter.users && this.filter.users?.length > 0;
  }
  @Watch('$route.name')
  async onRouteChange() {
    if (this.$route.name === 'tasks.edit') {
      await this.loadTasks();
    }
  }

  async loadTask() {
    this.$Progress.start();

    try {
      const response = await TaskApi.getTasks({
        ...this.filter,
        agency: this.user.agency,
        showDemo: this.showDemo,
      });

      if (this.$route.name === 'tasks.edit') {
        // set variable selectedTask in Modal
        // @ts-ignore
        (this.$refs['task-overview'] as TaskOverview).selectedTask = response.data.find(
          (task: ITask) => task.id === this.$route.params.id,
        );
      }
    } catch (e) {
      this.$toastr.e(
        'Beim Laden der Task ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
    this.$Progress.finish();
  }

  async loadTasks() {
    this.$Progress.start();

    try {
      this.filter = this.taskFilter;

      this.filter.taskIds = undefined;

      const response = await TaskApi.getTasks({
        ...this.filter,
        agency: this.user.agency,
        showDemo: this.showDemo,
      });

      this.tasks = response.data;

      const taskCountsResponse = await TaskApi.getTaskCounts({
        ...this.filter,
        agency: this.user.agency,
        showDemo: this.showDemo,
      });
      this.taskCounts = taskCountsResponse.data;

      if (this.$route.name === 'tasks.edit') {
        const response = await TaskApi.getTasks({
          ...this.filter,
          agency: this.user.agency,
          taskIds: [this.$route.params.id],
          showDemo: this.showDemo,
        });
        const selectedTask =
          response.data.find((task: ITask) => task.id === this.$route.params.id) || null;
        // set variable selectedTask in Modal
        // @ts-ignore
        (this.$refs['task-overview'] as TaskOverview).selectedTask = selectedTask;
      }
    } catch (e) {
      this.$toastr.e(
        'Beim Laden der Tasks ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );

      throw e;
    }
    this.$Progress.finish();
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        agency: this.agency,
        category: TagCategory.Tasks,
      });
      this.tags = response.data;
    } catch (e) {
      this.$toastr.e(
        'Beim Laden der Tags ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }

  get filteredTasks(): ITask[] {
    return this.tasks;
    // .sort(compare);
  }

  async deleteTag(tag: ITag) {
    try {
      await TagApi.delete({
        tag,
      });
      this.filter.tags = [];
      await this.loadTags();
      await this.loadTasks();
    } catch (e) {
      this.$toastr.e(
        'Beim Löschen des Tags ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }

  async reload() {
    await this.loadTags();
    await this.loadTasks();
  }

  isTagSelected(tag: ITag) {
    return this.filter.tags?.map((tag: ITag) => tag.id).includes(tag.id);
  }
  async toggleSelectTag(tag: ITag) {
    if (this.filter.tags && this.filter.tags.length > 0 && tag.id === this.filter.tags[0].id) {
      this.filter.tags = [];
    } else {
      this.filter.tags = [tag];
    }
    await this.reload();
  }

  tagClass(tagIndex: number) {
    return this.tagClasses[tagIndex % this.tagClasses.length];
  }
  openCreatePolicyModal() {
    (
      (this.$refs['create-policy-modal'] as CreatePolicyModal).$refs['create-policy'] as BModal
    ).show();
  }
  openCreateTaskModal() {
    ((this.$refs['create-task-modal'] as CreatePolicyModal).$refs['task-policy'] as BModal).show();
  }
}

export default Tasks;
